module.exports = __webpack_public_path__ + "img/logo-topdoctors-vertical-white.ba342225.svg";